import { CircleCheck, Info, TriangleAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './Notice.module.css';

export interface NoticeProps {
  readonly tone?: 'info' | 'warning' | 'error' | 'success';
  readonly title?: string;
  readonly children?: ReactNode;
  /** Announce to assistive technology (use for errors that appear after an action). */
  readonly live?: boolean;
}

export function Notice({ tone = 'info', title, children, live }: NoticeProps) {
  const icon =
    tone === 'success' ? (
      <CircleCheck aria-hidden />
    ) : tone === 'info' ? (
      <Info aria-hidden />
    ) : (
      <TriangleAlert aria-hidden />
    );
  return (
    <div
      className={`${styles.notice} ${styles[tone]}`}
      {...(live ? { role: tone === 'error' ? 'alert' : 'status' } : {})}
    >
      {icon}
      <div className={styles.content}>
        {title ? <span className={styles.title}>{title}</span> : null}
        {children}
      </div>
    </div>
  );
}

export function EmptyState({
  title,
  children,
  action,
}: {
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className={styles.empty}>
      <h3>{title}</h3>
      {children}
      {action}
    </div>
  );
}
